module.exports = __webpack_public_path__ + "static/RAMSA-Portrait-mobile-7d1b6a53630eef2c4df7d1beac486857.jpg";